var map = {
	"./03_get_deposit_hisrec.json": "dXH3",
	"./04_get_withdraw_history.json": "kh23",
	"./05_post_wallets_coins.json": "zgmp",
	"./06_post_wallets_withdraw.json": "YSKw",
	"./13.get_wallet_queryDepositAddress.json": "rgh9",
	"./14_get_risk_deposit_records.json": "CxZu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "M2/h";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/api/wallet \.json$
// module id = M2/h
// module chunks = 3